<div class="focus-my-offerings">
  <div class="my-offerings-header">
    <h2 class="ui-heading-3-bold title">My offerings</h2>
    <div class="buttons">
      <!-- <button
        rds-primary-button
        size="l"
        (click)="handleRequestDialog()"
        [attr.aria-label]="'Request new offering'"
      >
        <rds-icon icon="plus" namespace="filled" />Request new offering
      </button> -->
      <!-- <button
        rds-primary-button
        size="l"
        [routerLink]="['/focus/offering']"
        [attr.aria-label]="'Add new offering'"
      >
        <rds-icon icon="plus" namespace="filled" />Add new offering
      </button> -->

      <div rdsDropdown autofocusFirstItem>
        <button rds-dropdown-toggle-primary-button>
          {{ BUTTONS.ADD_NEW_OFFERING }}
        </button>
        <div *rdsDropdownMenu>
          <ul rds-list-item-container>
            <li *inexpFeatureFlag="'focus_inexp_904_application_form'">
              <button
                rds-list-item
                [routerLink]="[
                  '/focus/offering',
                  OFFERING_TYPE_ROUTE[OfferingType.APPLICATION],
                ]"
                [attr.aria-label]="'Add application'"
                tabindex="0"
              >
                {{ BUTTONS.ADD_APPLICATION }}
              </button>
            </li>
            <li *inexpFeatureFlag="'focus_inexp_1855_infrastructure_form'">
              <button
                rds-list-item
                [routerLink]="[
                  '/focus/offering',
                  OFFERING_TYPE_ROUTE[OfferingType.INFRASTRUCTURE],
                ]"
                [attr.aria-label]="'Add infrastructure'"
                tabindex="0"
              >
                {{ BUTTONS.ADD_INFRASTRUCTURE }}
              </button>
            </li>
            <li *inexpFeatureFlag="'focus_inexp_1861_platform_form'">
              <button
                rds-list-item
                [routerLink]="[
                  '/focus/offering',
                  OFFERING_TYPE_ROUTE[OfferingType.PLATFORM],
                ]"
                [attr.aria-label]="'Add platform'"
                tabindex="0"
              >
                {{ BUTTONS.ADD_PLATFORM }}
              </button>
            </li>
            <li *inexpFeatureFlag="'focus_inexp_1867_service_form'">
              <button
                rds-list-item
                [routerLink]="[
                  '/focus/offering',
                  OFFERING_TYPE_ROUTE[OfferingType.PROFESSIONAL_SERVICE],
                ]"
                [attr.aria-label]="'Add Professional service'"
                tabindex="0"
              >
                {{ BUTTONS.ADD_PROFESSIONAL_SERVICE }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <!-- <h3 class="ui-label-m-bold subtitle">
    Quality seal status
    <rds-icon
      rdsTooltip="A mechanism to ensure the overall integrity and quality of an offering"
      namespace="outlined"
      icon="circle_info"
    />
  </h3> -->
  <div class="my-offerings-content">
    <rds-tabs>
      <div class="filtering-options">
        <rds-form-field labelPosition="top" class="search">
          <rds-control-label>Search</rds-control-label>
          <rds-icon rds-control-prefix namespace="outlined" icon="search" />
          <input
            rdsInput
            (input)="searchQuery.set($event.target.value)"
            placeholder="Type search phrase here..."
          />
        </rds-form-field>

        <div class="filters">
          <rds-form-field labelPosition="top" class="role"
            ><rds-control-label>Role</rds-control-label>
            <rds-select
              placeholder="All"
              (valueChange)="selectedRole.set($event)"
            >
              <rds-select-option value="all">All</rds-select-option>
              @for (role of roles; track role) {
                <rds-select-option [value]="role">{{ role }}</rds-select-option>
              }
            </rds-select>
          </rds-form-field>
          <rds-form-field labelPosition="top" class="sort"
            ><rds-control-label>Sort by</rds-control-label>
            <rds-select
              placeholder="Newset to oldest"
              (valueChange)="sortOrder.set($event)"
            >
              <rds-select-option value="newest"
                >Newest to oldest</rds-select-option
              >
              <rds-select-option value="oldest"
                >Oldest to newest</rds-select-option
              >
            </rds-select>
          </rds-form-field>
        </div>
      </div>

      <rds-tab>
        <ng-template rds-tab-label>
          <span>All</span
          ><rds-badge
            [label]="totalOfferings()"
            size="s"
            color="neutral"
          ></rds-badge>
        </ng-template>

        @if (isLoading()) {
          <div class="tab-content">
            @for (item of skeletonItems; track $index) {
              <inexp-card-skeleton />
            }
          </div>
        } @else if (totalOfferings() > 0) {
          <div class="tab-content">
            @for (offering of paginatedOfferings(); track $index) {
              <inexp-focus-card [offering]="offering"></inexp-focus-card>
            }
          </div>
        } @else {
          <div class="empty-result">
            <div class="label ui-label-l-bold">{{ OFFERINGS_TEXTS.EMPTY_STATE.HEADING }}</div>
            <div class="hint ui-body-m">
              {{ OFFERINGS_TEXTS.EMPTY_STATE.TEXT }}
            </div>
            <!-- <button
            rds-primary-button
            size="l"
            (click)="handleRequestDialog()"
            [attr.aria-label]="'Request new offering'"
          >
            <rds-icon icon="plus" namespace="filled" />Request new offering
          </button> -->
          </div>
        }
      </rds-tab>
      <!-- <rds-tab disabled>
        <ng-template rds-tab-label>
          <span>Drafts</span
          ><rds-badge
            [label]="offerings.length"
            size="s"
            color="neutral"
          ></rds-badge>
        </ng-template>
        @if (offerings.length > 0) {
        <div class="tab-content">
          @for (offering of offerings(); track $index) {
          <inexp-focus-card [offering]="offering"></inexp-focus-card>
          }
        </div>

        } @else {
        <div class="empty-result">
          <div class="label ui-label-l-bold">No offerings assigned yet</div>
          <div class="hint ui-body-m">
            Request a new offering from Panorama Team
          </div>
          <button
            rds-primary-button
            size="l"
            [routerLink]="['/request-offering']"
            [attr.aria-label]="'Request new offering'"
          >
            <rds-icon icon="plus" namespace="filled" />Request new offering
          </button>
        </div>
        }
      </rds-tab>
      <rds-tab disabled>
        <ng-template rds-tab-label>
          <span>Check needed</span
          ><rds-badge
            [label]="offerings.length"
            size="s"
            color="neutral"
          ></rds-badge>
        </ng-template>
        @if (offerings.length > 0) { Display offerings } @else {
        <div class="empty-result">
          <div class="label ui-label-l-bold">No offerings assigned yet</div>
          <div class="hint ui-body-m">
            Request a new offering from Panorama Team
          </div>
          <button
            rds-primary-button
            size="l"
            [routerLink]="['/request-offering']"
            [attr.aria-label]="'Request new offering'"
          >
            <rds-icon icon="plus" namespace="filled" />Request new offering
          </button>
        </div>
        }
      </rds-tab>
      <rds-tab disabled>
        <ng-template rds-tab-label>
          <span>Approved</span
          ><rds-badge
            [label]="offerings.length"
            size="s"
            color="neutral"
          ></rds-badge>
        </ng-template>
        @if (offerings.length > 0) { Display offerings } @else {
        <div class="empty-result">
          <div class="label ui-label-l-bold">No offerings assigned yet</div>
          <div class="hint ui-body-m">
            Request a new offering from Panorama Team
          </div>
          <button
            rds-primary-button
            size="l"
            [routerLink]="['/request-offering']"
            [attr.aria-label]="'Request new offering'"
          >
            <rds-icon icon="plus" namespace="filled" />Request new offering
          </button>
        </div>
        }
      </rds-tab>
      <rds-tab disabled>
        <ng-template rds-tab-label>
          <span>Rejected</span
          ><rds-badge
            [label]="offerings.length"
            size="s"
            color="neutral"
          ></rds-badge>
        </ng-template>
        @if (offerings.length > 0) { Display offerings } @else {
        <div class="empty-result">
          <div class="label ui-label-l-bold">No offerings assigned yet</div>
          <div class="hint ui-body-m">
            Request a new offering from Panorama Team
          </div>
          <button
            rds-primary-button
            size="l"
            [routerLink]="['/request-offering']"
            [attr.aria-label]="'Request new offering'"
          >
            <rds-icon icon="plus" namespace="filled" />Request new offering
          </button>
        </div>
        }
      </rds-tab> -->
    </rds-tabs>
  </div>
  @if (totalOfferings() > itemsPerPage()) {
    <rds-paginator
      class="pagination"
      [length]="totalOfferings()"
      [pageSize]="itemsPerPage()"
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      hidePageSize
      (page)="handlePageEvent($event)"
    >
    </rds-paginator>
  }
</div>
